<template>
  <div
    :class="$style.logo"
    :style="{
      backgroundImage: `url(${LogoImage})`,
    }"
  >
  </div>
</template>

<script>
import LogoImage from '@/assets/images/logo.svg'

export default {
  props: {
  },
  data () {
    return {
      LogoImage,
    }
  },
}
</script>

<style lang="scss" module>
.logo {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  background: no-repeat center/contain;
}
</style>
